import {useSelector} from "react-redux";

const getUser= (state: any) => state.user

export default function  useCurrentUser(){
  return useSelector(getUser)
}

const getLang= (state: any) => state.user.locale

export function  useCurrentLang(){
  return useSelector(getLang)
}
